/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';
import {Fade} from 'react-reveal';
import { Row, Col } from 'react-bootstrap';

import BaseComponent from "../../../panther/components/base/BaseComponent";
import './style.css';
import classNames from "classnames";

class Footer extends BaseComponent {
    constructor(props) {
        super(props);
    }

    render(){
        return (
            <footer className="climate-fit-footer" id="contact">
                <div className="container">
                    <Row className="show-grid container contact">
                        <Col xs={12} sm={12} md={4} lg={4}>
                            <div className="contact-section-title">Contact us</div>
                            <div className="contact-section-item">
                                <div className="contact-section-item-title">Team Leader</div>
                                <div className="contact-section-item-text">Kateřina Jupová</div>
                            </div>
                            <div className="contact-section-item">
                                <div className="contact-section-item-title">E-mail</div>
                                <div className="contact-section-item-text">katerina.jupova@gisat.cz</div>
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4}>
                            <div className="contact-section-title">Our office</div>
                            <div className="contact-section-item">
                                <div className="contact-section-item-text">Gisat s.r.o</div>
                                <div className="contact-section-item-text">Milady Horakove 57</div>
                                <div className="contact-section-item-text">170 00 Praha 7</div>
                                <div className="contact-section-item-text">Czech Republic</div>
                            </div>
                        </Col>
                        <Col className="climate-fit-footer-logos" xs={12} sm={12} md={4} lg={4}>
                            <a title="Gisat s.r.o | www.gisat.cz" key="gisat" target="_blank" href="http://gisat.cz/content/en"><img alt="gisat" src={require("../../../resources/img/logo-gisat.png")}/></a>
                            <a title="Climate-fity.city" key="climate-fit" target="_blank" href="https://www.climate-fit.city"><img alt="climate-fit" src={require("../../../resources/img/logo-climate-fit.png")}/></a>
                        </Col>

                    </Row>
                </div>
                <hr/>
                <div className="container">
                <Row className="show-grid copyright container">
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <div className="climate-fit-copyright-eu">
                            <div className="eu-flag">{this.renderEuFlag()}</div>
                            <p>Climate-fit.city is developed as part of the PUCS project, which has received funding from the European Union’s H2020 Research and Innovation Programme under Grant Agreement No. 73004</p>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <div className="climate-fit-copyright-gisat">
                            {this.renderCopyright()}
                        </div>
                    </Col>
                </Row>
                </div>
            </footer>
        );
    }

    renderCopyright(){
        let copy = `© Gisat ${new Date().getFullYear()}`;

        return (
            <p>{copy}</p>
        );
    }

    renderEuFlag(){
        return (
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" width="54" height="36">
                <desc>European flag</desc>
                <defs>
                    <g id="s">
                        <g id="c">
                            <path id="t" d="M0,0v1h0.5z" transform="translate(0,-1)rotate(18)" />
                            <use xlinkHref="#t" transform="scale(-1,1)" />
                        </g>
                        <g id="a">
                            <use xlinkHref="#c" transform="rotate(72)" />
                            <use xlinkHref="#c" transform="rotate(144)" />
                        </g>
                        <use xlinkHref="#a" transform="scale(-1,1)" />
                    </g>
                </defs>
                <rect fill="#039" width="54" height="36" />
                <g fill="#fc0" transform="scale(2)translate(13.5,9)">
                    <use xlinkHref="#s" y="-6" />
                    <use xlinkHref="#s" y="6" />
                    <g id="l">
                        <use xlinkHref="#s" x="-6" />
                        <use xlinkHref="#s" transform="rotate(150)translate(0,6)rotate(66)" />
                        <use xlinkHref="#s" transform="rotate(120)translate(0,6)rotate(24)" />
                        <use xlinkHref="#s" transform="rotate(60)translate(0,6)rotate(12)" />
                        <use xlinkHref="#s" transform="rotate(30)translate(0,6)rotate(42)" />
                    </g>
                    <use xlinkHref="#l" transform="scale(-1,1)" />
                </g>
            </svg>
        );
    }
}

export default Footer;
